/**
 * 线上环境
 */
export const ONLINEHOST: string = 'http://baoen.51vip.biz/'

/**
 * 测试环境
 */
export const QAHOST: string = 'http://localhost:9097/api'

/**
 * 线上mock
 */
export const MOCKHOST: string = 'http://xxx.com'

/**
 * 是否mock
 */
export const ISMOCK: boolean = true

/**
 * 当前的host  ONLINEHOST | QAHOST | MOCKHOST
 */
const protocol = location.protocol
const hostname = location.hostname
const port = location.port

var host = "http://" + hostname

if (protocol && protocol == "https:") {
    host = "https://" + hostname
}

if (port && port != "80" && port != "443") {
    host += ":" + port
}

host += "/api"

export const MAINHOST: string = host

/**
 * 请求的公共参数
 */
export const commonPrams: any = {}

/**
 * @description token在Cookie中存储的天数，默认1天
 */
export const cookieExpires: number = 1
